/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
// import React, { useEffect, useState } from 'react';
// import { Button, TabContent, TabPane } from 'reactstrap';
// import { isEmpty } from 'lodash';
// import { useDispatch } from 'react-redux';
// import { useQuery } from '@apollo/client';
// import { ArrowRightToLine } from 'lucide-react';
// import {
//   NOTIFICATION_QUERY,
//   NOTIFICATION_SUBSCRIPTION_QUERY,
// } from 'pages/Notifications/NotificationGraphQL';
// import { setVendorDetails } from 'actions/vendorDetailsAction';
// import Loader from 'components/common/Loader';
// import moment from 'moment';
// import FSBModal from 'components/common/FSBModal';
// import NoDataFound from 'components/NoDataFound';
// import { NOTIFICATION_TABS_HEADING } from 'pages/Products/constant';
// import CustomTabs from 'components/CustomTabs';
// import Notifications from '../Notifications';
// import CustomNotification from '../CustomNotification';
// import WhatsNew from './Whatsnew/index';
// import WhatsNewStatic from './WhatsNewStatic';
// import CustomNotificationStatic from './CustomNotificationStatic';
// import 'react-datepicker/dist/react-datepicker.css';
// import DateRangeFilter from './DateRangePicker';

// const AllNotification = () => {
//   const dispatch = useDispatch();
//   const [showCustomNotification, setShowCustomNotification] = useState(false);
//   const [showWhatsNew, setShowWhatsNew] = useState(false);

//   // New states for static sidebars
//   const [showWhatsNewStatic, setShowWhatsNewStatic] = useState(false);
//   const [showCustomNotificationStatic, setShowCustomNotificationStatic] = useState(false);

//   const toggleCustomNotification = () => {
//     setShowCustomNotification(!showCustomNotification);
//   };

//   const toggleWhatsNew = () => {
//     setShowWhatsNew(!showWhatsNew);
//   };

//   // New toggle functions for static sidebars
//   const toggleWhatsNewStatic = () => {
//     setShowWhatsNewStatic(!showWhatsNewStatic);
//   };

//   const toggleCustomNotificationStatic = () => {
//     setShowCustomNotificationStatic(!showCustomNotificationStatic);
//   };

//   const todayDate = new Date();
//   const date = moment(todayDate);
//   const yesterdayDate = date.subtract(1, 'days').toDate();
//   const yesterDateAndTimeMilliseconds = yesterdayDate.valueOf();

//   const [activeTab, setActiveTab] = useState(NOTIFICATION_TABS_HEADING.ALL);

//   const defaultFilter = {
//     filter: [
//       {
//         key: 'forAdminOnly',
//         value: true,
//         type: 'BOOLEAN',
//         op: 'EQ',
//       },
//     ],
//     pageNo: 1,
//     pageSize: 100000,
//     sortCol: null,
//     sortDirection: null,
//   };

//   const [filters, setFilters] = useState(JSON.parse(JSON.stringify(defaultFilter)));
//   const [dateRange, setDateRange] = useState({ startDate: null, endDate: null });

//   const handlePageChange = ({ pageSize, pageNo }) => {
//     setFilters({
//       ...filters,
//       pageNo,
//       pageSize,
//     });
//   };

//   const getValue = (tab) => {
//     if (NOTIFICATION_TABS_HEADING.BIDS === tab) {
//       return 'bid';
//     }
//     if (NOTIFICATION_TABS_HEADING.ORDERS === tab) {
//       return 'order';
//     }
//     if (NOTIFICATION_TABS_HEADING.USERS === tab) {
//       return ['trader'];
//     }
//     if (NOTIFICATION_TABS_HEADING.OFFER === tab) {
//       return 'offer';
//     }
//     if (NOTIFICATION_TABS_HEADING.DEMAND === tab) {
//       return ['demand', 'NEW_DEMAND'];
//     }
//     if (NOTIFICATION_TABS_HEADING.OTHERS === tab) {
//       return ['bid', 'order', 'KYC', 'offer', 'demand', 'NEW_DEMAND', 'trader'];
//     }
//   };

//   const toggle = (tab) => {
//     setDateRange({ startDate: null, endDate: null });
//     if (activeTab !== tab) {
//       if (NOTIFICATION_TABS_HEADING.ALL === tab) {
//         setFilters(JSON.parse(JSON.stringify(defaultFilter)));
//       } else {
//         const value = getValue(tab);
//         const isArray = Array.isArray(value);

//         let filterConfig;

//         if (tab === NOTIFICATION_TABS_HEADING.DEMAND || tab === NOTIFICATION_TABS_HEADING.USERS) {
//           filterConfig = {
//             key: 'typeName',
//             value: value.join(','),
//             type: 'STRING',
//             op: 'IN',
//           };
//         } else if (tab === NOTIFICATION_TABS_HEADING.OTHERS) {
//           filterConfig = {
//             key: 'typeName',
//             value: value.join(','),
//             type: 'STRING',
//             op: 'NOT_IN',
//           };
//         } else {
//           filterConfig = {
//             key: 'typeName',
//             value,
//             type: 'STRING',
//             op: 'EQ',
//           };
//         }

//         setFilters({
//           ...JSON.parse(JSON.stringify(defaultFilter)),
//           filter: [...defaultFilter.filter, filterConfig],
//         });
//       }
//       setActiveTab(tab);
//     }
//   };

//   const { data, loading, error, subscribeToMore } = useQuery(NOTIFICATION_QUERY, {
//     variables: filters,
//     fetchPolicy: 'network-only',
//   });

//   useEffect(() => {
//     const unsubscribe = subscribeToMore({
//       document: NOTIFICATION_SUBSCRIPTION_QUERY,
//       variables: filters,
//       updateQuery: (prev, { subscriptionData }) => {
//         if (!prev || isEmpty(prev)) return '';
//         if (!subscriptionData.data) return prev;
//         return subscriptionData.data;
//       },
//     });
//     return () => unsubscribe();
//   }, []);

//   const handleClick = (val) => {
//     if (val?.id)
//       dispatch(
//         setVendorDetails({
//           status: true,
//           selectedVendor: val,
//         })
//       );
//   };

//   const handleWhatsNewStaticClick = () => {
//     toggleWhatsNewStatic();
//   };

//   const handleWhatsNewStaticKeyDown = (e) => {
//     if (e.key === 'Enter' || e.key === ' ') {
//       e.preventDefault();
//       toggleWhatsNewStatic();
//     }
//   };

//   const handleBackdropClick = () => {
//     setShowWhatsNewStatic(false);
//     setShowCustomNotificationStatic(false);
//   };

//   const handleBackdropKeyDown = (e) => {
//     if (e.key === 'Enter' || e.key === ' ') {
//       e.preventDefault();
//       setShowWhatsNewStatic(false);
//       setShowCustomNotificationStatic(false);
//     }
//   };

//   if (loading)
//     return (
//       <div className="pb-5">
//         <Loader />
//       </div>
//     );
//   if (error) return `There is an error on this page : ${error.message} `;
//   if (!data?.notifications?.notifications)
//     return (
//       <div className="pb-5">
//         <NoDataFound message="Notifications not available" />
//       </div>
//     );

//   return (
//     <>
//       <div className="text-end d-flex justify-content-end gap-2">
//         {/* What's New Section - Separate Icon and Button */}
//         <div className="d-flex align-items-center gap-2">

//           <Button
//             color="warning"
//             className="text-nowrap mb-3 mt-sm-0"
//             size="sm"
//             onClick={toggleWhatsNew}
//             style={{ border: "none", background: "#2378C9", color: "white" }}
//           >
//             What&apos;s New
//           </Button>

//           <div
//             onClick={handleWhatsNewStaticClick}
//             onKeyDown={handleWhatsNewStaticKeyDown}
//             role="button"
//             tabIndex={0}
//             style={{
//               cursor: 'pointer',
//               background: '#2378C9',
//               borderRadius: '4px',
//               padding: '6px 8px',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               marginBottom:"15px",
//             }}
//           >
//             <ArrowRightToLine size={16} color="white" />
//           </div>
//         </div>

//         {/* Custom Notification Section - Separate Icon and Button */}
//         <div className="d-flex align-items-center gap-2">

//           <Button
//             color="primary"
//             className="text-nowrap mb-3 mt-sm-0"
//             size="sm"
//             onClick={toggleCustomNotification}
//           >
//             Custom Notification
//           </Button>

//             <div
//             onClick={toggleCustomNotificationStatic}
//             onKeyDown={handleWhatsNewStaticKeyDown}
//             role="button"
//             tabIndex={0}
//             style={{
//               cursor: 'pointer',
//               background: '#2378C9',
//               borderRadius: '4px',
//               padding: '6px 8px',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               marginBottom:"15px",
//             }}
//           >
//             <ArrowRightToLine size={16} color="white" />
//           </div>
//         </div>
//       </div>

//       <div style={{ position: 'relative' }}>
//         <CustomTabs
//           tabs={[
//             NOTIFICATION_TABS_HEADING.ALL,
//             NOTIFICATION_TABS_HEADING.ORDERS,
//             NOTIFICATION_TABS_HEADING.BIDS,
//             NOTIFICATION_TABS_HEADING.USERS,
//             NOTIFICATION_TABS_HEADING.OFFER,
//             NOTIFICATION_TABS_HEADING.DEMAND,
//             NOTIFICATION_TABS_HEADING.OTHERS,
//           ]}
//           selectedTab={activeTab}
//           onTabChange={toggle}
//           className="mb-2"
//         />
//         <div style={{ position: 'absolute', right: 0, top: 0 }}>
//           <DateRangeFilter
//             dateRange={dateRange}
//             onFilter={({ startDate, endDate }) => {
//               if (!startDate && !endDate) {
//                 setDateRange({ startDate: null, endDate: null });
//                 setFilters((prev) => ({
//                   ...prev,
//                   filter: [...prev.filter.filter((filter) => filter?.key !== 'createdAt')],
//                 }));
//                 return;
//               }
//               setDateRange({ startDate, endDate });
//               setFilters((prev) => ({
//                 ...prev,
//                 filter: [
//                   ...prev.filter.filter((filter) => filter?.key !== 'createdAt'),
//                   {
//                     key: 'createdAt',
//                     value: startDate.valueOf(),
//                     type: 'DATE',
//                     op: 'GTE',
//                   },
//                   {
//                     key: 'createdAt',
//                     value: endDate.valueOf(),
//                     type: 'DATE',
//                     op: 'LTE',
//                   },
//                 ],
//               }));
//             }}
//           />
//         </div>
//       </div>

//       <TabContent activeTab={activeTab}>
//         <TabPane tabId={NOTIFICATION_TABS_HEADING.ALL}>
//           {activeTab === NOTIFICATION_TABS_HEADING.ALL && (
//             <Notifications
//               handlePageChange={handlePageChange}
//               data={data}
//               handleClick={handleClick}
//               totalCount={(data && data?.notifications?.totalCount) || 0}
//               totalPages={(data && data?.notifications?.totalPages) || 0}
//               pageSize={filters.pageSize}
//               currentPageNo={filters.pageNo}
//             />
//           )}
//         </TabPane>
//         <TabPane tabId={NOTIFICATION_TABS_HEADING.BIDS}>
//           {activeTab === NOTIFICATION_TABS_HEADING.BIDS && (
//             <Notifications
//               handlePageChange={handlePageChange}
//               data={data}
//               handleClick={handleClick}
//               totalCount={(data && data?.notifications?.totalCount) || 0}
//               totalPages={(data && data?.notifications?.totalPages) || 0}
//               pageSize={filters.pageSize}
//               currentPageNo={filters.pageNo}
//             />
//           )}
//         </TabPane>
//         <TabPane tabId={NOTIFICATION_TABS_HEADING.ORDERS}>
//           {activeTab === NOTIFICATION_TABS_HEADING.ORDERS && (
//             <Notifications
//               handlePageChange={handlePageChange}
//               data={data}
//               handleClick={handleClick}
//               totalCount={(data && data?.notifications?.totalCount) || 0}
//               totalPages={(data && data?.notifications?.totalPages) || 0}
//               pageSize={filters.pageSize}
//               currentPageNo={filters.pageNo}
//             />
//           )}
//         </TabPane>
//         <TabPane tabId={NOTIFICATION_TABS_HEADING.USERS}>
//           {activeTab === NOTIFICATION_TABS_HEADING.USERS && (
//             <Notifications
//               handlePageChange={handlePageChange}
//               data={data}
//               handleClick={handleClick}
//               totalCount={(data && data?.notifications?.totalCount) || 0}
//               totalPages={(data && data?.notifications?.totalPages) || 0}
//               pageSize={filters.pageSize}
//               currentPageNo={filters.pageNo}
//             />
//           )}
//         </TabPane>
//         <TabPane tabId={NOTIFICATION_TABS_HEADING.OFFER}>
//           {activeTab === NOTIFICATION_TABS_HEADING.OFFER && (
//             <Notifications
//               handlePageChange={handlePageChange}
//               data={data}
//               handleClick={handleClick}
//               totalCount={(data && data?.notifications?.totalCount) || 0}
//               totalPages={(data && data?.notifications?.totalPages) || 0}
//               pageSize={filters.pageSize}
//               currentPageNo={filters.pageNo}
//             />
//           )}
//         </TabPane>
//         <TabPane tabId={NOTIFICATION_TABS_HEADING.DEMAND}>
//           {activeTab === NOTIFICATION_TABS_HEADING.DEMAND && (
//             <Notifications
//               handlePageChange={handlePageChange}
//               data={data}
//               handleClick={handleClick}
//               totalCount={(data && data?.notifications?.totalCount) || 0}
//               totalPages={(data && data?.notifications?.totalPages) || 0}
//               pageSize={filters.pageSize}
//               currentPageNo={filters.pageNo}
//             />
//           )}
//         </TabPane>
//         <TabPane tabId={NOTIFICATION_TABS_HEADING.OTHERS}>
//           {activeTab === NOTIFICATION_TABS_HEADING.OTHERS && (
//             <Notifications
//               handlePageChange={handlePageChange}
//               data={data}
//               handleClick={handleClick}
//               totalCount={(data && data?.notifications?.totalCount) || 0}
//               totalPages={(data && data?.notifications?.totalPages) || 0}
//               pageSize={filters.pageSize}
//               currentPageNo={filters.pageNo}
//             />
//           )}
//         </TabPane>
//       </TabContent>

//       {/* Custom Notification Modal */}
//       <FSBModal
//         title="Send Custom Notification"
//         closeButtonLabel=""
//         confirmButtonLabel=""
//         message=""
//         open={showCustomNotification}
//         toggleAlert={toggleCustomNotification}
//         onClose={toggleCustomNotification}
//         modalClass="right-drawer notification-drawer"
//       >
//         <CustomNotification toggleCustomNotification={toggleCustomNotification} />
//       </FSBModal>

//       {/* What's New Modal */}
//       <FSBModal
//         title="What&apos;s New"
//         closeButtonLabel=""
//         confirmButtonLabel=""
//         message=""
//         open={showWhatsNew}
//         toggleAlert={toggleWhatsNew}
//         onClose={toggleWhatsNew}
//         modalClass="right-drawer notification-drawer"
//       >
//         <WhatsNew toggleWhatsNew={toggleWhatsNew} />
//       </FSBModal>

//       {/* What's New Static Sidebar */}
//       {showWhatsNewStatic && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 0,
//             right: 0,
//             width: '400px',
//             height: '100vh',
//             background: '#fff',
//             boxShadow: '-2px 0 10px rgba(0,0,0,0.2)',
//             zIndex: 9999,
//             overflowY: 'auto',
//           }}
//         >
//           <WhatsNewStatic onClose={toggleWhatsNewStatic} />
//         </div>
//       )}

//       {/* Custom Notification Static Sidebar */}
//       {showCustomNotificationStatic && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 0,
//             right: 0,
//             width: '400px',
//             height: '100vh',
//             background: '#fff',
//             boxShadow: '-2px 0 10px rgba(0,0,0,0.2)',
//             zIndex: 9999,
//             overflowY: 'auto',
//           }}
//         >
//           <CustomNotificationStatic onClose={toggleCustomNotificationStatic} />
//         </div>
//       )}

//       {/* Backdrop for sidebars */}
//       {(showWhatsNewStatic || showCustomNotificationStatic) && (
//         <div
//           onClick={handleBackdropClick}
//           onKeyDown={handleBackdropKeyDown}
//           role="button"
//           tabIndex={0}
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             width: '100%',
//             height: '100%',
//             background: 'rgba(0,0,0,0.5)',
//             zIndex: 9998,
//           }}
//         />
//       )}
//     </>
//   );
// };

// export default AllNotification;

// import React, { useEffect, useState } from 'react';
// import { Button, TabContent, TabPane } from 'reactstrap';
// import { isEmpty } from 'lodash';
// import { useDispatch } from 'react-redux';
// import { useQuery } from '@apollo/client';
// import { ArrowRightToLine, ExternalLink } from 'lucide-react';
// import {
//   NOTIFICATION_QUERY,
//   NOTIFICATION_SUBSCRIPTION_QUERY,
// } from 'pages/Notifications/NotificationGraphQL';
// import { setVendorDetails } from 'actions/vendorDetailsAction';
// import Loader from 'components/common/Loader';
// import moment from 'moment';
// import FSBModal from 'components/common/FSBModal';
// import NoDataFound from 'components/NoDataFound';
// import { NOTIFICATION_TABS_HEADING } from 'pages/Products/constant';
// import CustomTabs from 'components/CustomTabs';
// import Notifications from '../Notifications';
// import CustomNotification from '../CustomNotification';
// import WhatsNew from './Whatsnew/index';
// import WhatsNewStatic from './WhatsNewStatic';
// import CustomNotificationStatic from './CustomNotificationStatic';
// import 'react-datepicker/dist/react-datepicker.css';
// import DateRangeFilter from './DateRangePicker';

// const AllNotification = () => {
//   const dispatch = useDispatch();
//   const [showCustomNotification, setShowCustomNotification] = useState(false);
//   const [showWhatsNew, setShowWhatsNew] = useState(false);

//   // New states for static sidebars
//   const [showWhatsNewStatic, setShowWhatsNewStatic] = useState(false);
//   const [showCustomNotificationStatic, setShowCustomNotificationStatic] = useState(false);

//   const toggleCustomNotification = () => {
//     setShowCustomNotification(!showCustomNotification);
//   };

//   const toggleWhatsNew = () => {
//     setShowWhatsNew(!showWhatsNew);
//   };

//   // New toggle functions for static sidebars
//   const toggleWhatsNewStatic = () => {
//     setShowWhatsNewStatic(!showWhatsNewStatic);
//   };

//   const toggleCustomNotificationStatic = () => {
//     setShowCustomNotificationStatic(!showCustomNotificationStatic);
//   };

//   const todayDate = new Date();
//   const date = moment(todayDate);
//   const yesterdayDate = date.subtract(1, 'days').toDate();
//   const yesterDateAndTimeMilliseconds = yesterdayDate.valueOf();

//   const [activeTab, setActiveTab] = useState(NOTIFICATION_TABS_HEADING.ALL);

//   const defaultFilter = {
//     filter: [
//       {
//         key: 'forAdminOnly',
//         value: true,
//         type: 'BOOLEAN',
//         op: 'EQ',
//       },
//     ],
//     pageNo: 1,
//     pageSize: 100000,
//     sortCol: null,
//     sortDirection: null,
//   };

//   const [filters, setFilters] = useState(JSON.parse(JSON.stringify(defaultFilter)));
//   const [dateRange, setDateRange] = useState({ startDate: null, endDate: null });

//   const handlePageChange = ({ pageSize, pageNo }) => {
//     setFilters({
//       ...filters,
//       pageNo,
//       pageSize,
//     });
//   };

//   const getValue = (tab) => {
//     if (NOTIFICATION_TABS_HEADING.BIDS === tab) {
//       return 'bid';
//     }
//     if (NOTIFICATION_TABS_HEADING.ORDERS === tab) {
//       return 'order';
//     }
//     if (NOTIFICATION_TABS_HEADING.USERS === tab) {
//       return ['trader'];
//     }
//     if (NOTIFICATION_TABS_HEADING.OFFER === tab) {
//       return 'offer';
//     }
//     if (NOTIFICATION_TABS_HEADING.DEMAND === tab) {
//       return ['demand', 'NEW_DEMAND'];
//     }
//     if (NOTIFICATION_TABS_HEADING.OTHERS === tab) {
//       return ['bid', 'order', 'KYC', 'offer', 'demand', 'NEW_DEMAND', 'trader'];
//     }
//   };

//   const toggle = (tab) => {
//     setDateRange({ startDate: null, endDate: null });
//     if (activeTab !== tab) {
//       if (NOTIFICATION_TABS_HEADING.ALL === tab) {
//         setFilters(JSON.parse(JSON.stringify(defaultFilter)));
//       } else {
//         const value = getValue(tab);
//         const isArray = Array.isArray(value);

//         let filterConfig;

//         if (tab === NOTIFICATION_TABS_HEADING.DEMAND || tab === NOTIFICATION_TABS_HEADING.USERS) {
//           filterConfig = {
//             key: 'typeName',
//             value: value.join(','),
//             type: 'STRING',
//             op: 'IN',
//           };
//         } else if (tab === NOTIFICATION_TABS_HEADING.OTHERS) {
//           filterConfig = {
//             key: 'typeName',
//             value: value.join(','),
//             type: 'STRING',
//             op: 'NOT_IN',
//           };
//         } else {
//           filterConfig = {
//             key: 'typeName',
//             value,
//             type: 'STRING',
//             op: 'EQ',
//           };
//         }

//         setFilters({
//           ...JSON.parse(JSON.stringify(defaultFilter)),
//           filter: [...defaultFilter.filter, filterConfig],
//         });
//       }
//       setActiveTab(tab);
//     }
//   };

//   const { data, loading, error, subscribeToMore } = useQuery(NOTIFICATION_QUERY, {
//     variables: filters,
//     fetchPolicy: 'network-only',
//   });

//   useEffect(() => {
//     const unsubscribe = subscribeToMore({
//       document: NOTIFICATION_SUBSCRIPTION_QUERY,
//       variables: filters,
//       updateQuery: (prev, { subscriptionData }) => {
//         if (!prev || isEmpty(prev)) return '';
//         if (!subscriptionData.data) return prev;
//         return subscriptionData.data;
//       },
//     });
//     return () => unsubscribe();
//   }, []);

//   const handleClick = (val) => {
//     if (val?.id)
//       dispatch(
//         setVendorDetails({
//           status: true,
//           selectedVendor: val,
//         })
//       );
//   };

//   const handleWhatsNewStaticClick = () => {
//     toggleWhatsNewStatic();
//   };

//   const handleWhatsNewStaticKeyDown = (e) => {
//     if (e.key === 'Enter' || e.key === ' ') {
//       e.preventDefault();
//       toggleWhatsNewStatic();
//     }
//   };

//   const handleCustomNotificationStaticClick = () => {
//     toggleCustomNotificationStatic();
//   };

//   const handleCustomNotificationStaticKeyDown = (e) => {
//     if (e.key === 'Enter' || e.key === ' ') {
//       e.preventDefault();
//       toggleCustomNotificationStatic();
//     }
//   };

//   const handleBackdropClick = () => {
//     setShowWhatsNewStatic(false);
//     setShowCustomNotificationStatic(false);
//   };

//   const handleBackdropKeyDown = (e) => {
//     if (e.key === 'Enter' || e.key === ' ') {
//       e.preventDefault();
//       setShowWhatsNewStatic(false);
//       setShowCustomNotificationStatic(false);
//     }
//   };

//   if (loading)
//     return (
//       <div className="pb-5">
//         <Loader />
//       </div>
//     );
//   if (error) return `There is an error on this page : ${error.message} `;
//   if (!data?.notifications?.notifications)
//     return (
//       <div className="pb-5">
//         <NoDataFound message="Notifications not available" />
//       </div>
//     );

//   return (
//     <>
//       <div className="text-end d-flex justify-content-end gap-3">
//         {/* What&apos;s New Section */}
//         <div className="d-flex align-items-center gap-2">
//           <Button
//             color="warning"
//             className="text-nowrap mb-3 mt-sm-0 d-flex align-items-center gap-2"
//             size="sm"
//             onClick={toggleWhatsNew}
//             style={{ border: "none", background: "#2378C9", color: "white" }}
//           >
//             What&apos;s New
//           </Button>

//           <div
//             onClick={handleWhatsNewStaticClick}
//             onKeyDown={handleWhatsNewStaticKeyDown}
//             role="button"
//             tabIndex={0}
//             aria-label="Open What's New in new sidebar"
//             style={{
//               cursor: 'pointer',
//               background: '#2378C9',
//               borderRadius: '50%',
//               width: '32px',
//               height: '32px',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               marginBottom: '19px'
//             }}
//           >
//             <ExternalLink size={18} color="white" />
//           </div>
//         </div>

//         {/* Custom Notification Section */}
//         <div className="d-flex align-items-center gap-2">
//           <Button
//             color="primary"
//             className="text-nowrap mb-3 mt-sm-0 d-flex align-items-center gap-2"
//             size="sm"
//             onClick={toggleCustomNotification}
//           >
//             Custom Notification
//           </Button>

//           <div
//             onClick={handleCustomNotificationStaticClick}
//             onKeyDown={handleCustomNotificationStaticKeyDown}
//             role="button"
//             tabIndex={0}
//             aria-label="Open Custom Notification in new sidebar"
//             style={{
//               cursor: 'pointer',
//               background: '#2378C9',
//               borderRadius: '50%',
//               width: '32px',
//               height: '32px',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               marginBottom: '19px'
//             }}
//           >
//             <ExternalLink size={18} color="white" />
//           </div>

//         </div>
//       </div>

//       <div style={{ position: 'relative' }}>
//         <CustomTabs
//           tabs={[
//             NOTIFICATION_TABS_HEADING.ALL,
//             NOTIFICATION_TABS_HEADING.ORDERS,
//             NOTIFICATION_TABS_HEADING.BIDS,
//             NOTIFICATION_TABS_HEADING.USERS,
//             NOTIFICATION_TABS_HEADING.OFFER,
//             NOTIFICATION_TABS_HEADING.DEMAND,
//             NOTIFICATION_TABS_HEADING.OTHERS,
//           ]}
//           selectedTab={activeTab}
//           onTabChange={toggle}
//           className="mb-2"
//         />
//         <div style={{ position: 'absolute', right: 0, top: 0 }}>
//           <DateRangeFilter
//             dateRange={dateRange}
//             onFilter={({ startDate, endDate }) => {
//               if (!startDate && !endDate) {
//                 setDateRange({ startDate: null, endDate: null });
//                 setFilters((prev) => ({
//                   ...prev,
//                   filter: [...prev.filter.filter((filter) => filter?.key !== 'createdAt')],
//                 }));
//                 return;
//               }
//               setDateRange({ startDate, endDate });
//               setFilters((prev) => ({
//                 ...prev,
//                 filter: [
//                   ...prev.filter.filter((filter) => filter?.key !== 'createdAt'),
//                   {
//                     key: 'createdAt',
//                     value: startDate.valueOf(),
//                     type: 'DATE',
//                     op: 'GTE',
//                   },
//                   {
//                     key: 'createdAt',
//                     value: endDate.valueOf(),
//                     type: 'DATE',
//                     op: 'LTE',
//                   },
//                 ],
//               }));
//             }}
//           />
//         </div>
//       </div>

//       <TabContent activeTab={activeTab}>
//         <TabPane tabId={NOTIFICATION_TABS_HEADING.ALL}>
//           {activeTab === NOTIFICATION_TABS_HEADING.ALL && (
//             <Notifications
//               handlePageChange={handlePageChange}
//               data={data}
//               handleClick={handleClick}
//               totalCount={(data && data?.notifications?.totalCount) || 0}
//               totalPages={(data && data?.notifications?.totalPages) || 0}
//               pageSize={filters.pageSize}
//               currentPageNo={filters.pageNo}
//             />
//           )}
//         </TabPane>
//         <TabPane tabId={NOTIFICATION_TABS_HEADING.BIDS}>
//           {activeTab === NOTIFICATION_TABS_HEADING.BIDS && (
//             <Notifications
//               handlePageChange={handlePageChange}
//               data={data}
//               handleClick={handleClick}
//               totalCount={(data && data?.notifications?.totalCount) || 0}
//               totalPages={(data && data?.notifications?.totalPages) || 0}
//               pageSize={filters.pageSize}
//               currentPageNo={filters.pageNo}
//             />
//           )}
//         </TabPane>
//         <TabPane tabId={NOTIFICATION_TABS_HEADING.ORDERS}>
//           {activeTab === NOTIFICATION_TABS_HEADING.ORDERS && (
//             <Notifications
//               handlePageChange={handlePageChange}
//               data={data}
//               handleClick={handleClick}
//               totalCount={(data && data?.notifications?.totalCount) || 0}
//               totalPages={(data && data?.notifications?.totalPages) || 0}
//               pageSize={filters.pageSize}
//               currentPageNo={filters.pageNo}
//             />
//           )}
//         </TabPane>
//         <TabPane tabId={NOTIFICATION_TABS_HEADING.USERS}>
//           {activeTab === NOTIFICATION_TABS_HEADING.USERS && (
//             <Notifications
//               handlePageChange={handlePageChange}
//               data={data}
//               handleClick={handleClick}
//               totalCount={(data && data?.notifications?.totalCount) || 0}
//               totalPages={(data && data?.notifications?.totalPages) || 0}
//               pageSize={filters.pageSize}
//               currentPageNo={filters.pageNo}
//             />
//           )}
//         </TabPane>
//         <TabPane tabId={NOTIFICATION_TABS_HEADING.OFFER}>
//           {activeTab === NOTIFICATION_TABS_HEADING.OFFER && (
//             <Notifications
//               handlePageChange={handlePageChange}
//               data={data}
//               handleClick={handleClick}
//               totalCount={(data && data?.notifications?.totalCount) || 0}
//               totalPages={(data && data?.notifications?.totalPages) || 0}
//               pageSize={filters.pageSize}
//               currentPageNo={filters.pageNo}
//             />
//           )}
//         </TabPane>
//         <TabPane tabId={NOTIFICATION_TABS_HEADING.DEMAND}>
//           {activeTab === NOTIFICATION_TABS_HEADING.DEMAND && (
//             <Notifications
//               handlePageChange={handlePageChange}
//               data={data}
//               handleClick={handleClick}
//               totalCount={(data && data?.notifications?.totalCount) || 0}
//               totalPages={(data && data?.notifications?.totalPages) || 0}
//               pageSize={filters.pageSize}
//               currentPageNo={filters.pageNo}
//             />
//           )}
//         </TabPane>
//         <TabPane tabId={NOTIFICATION_TABS_HEADING.OTHERS}>
//           {activeTab === NOTIFICATION_TABS_HEADING.OTHERS && (
//             <Notifications
//               handlePageChange={handlePageChange}
//               data={data}
//               handleClick={handleClick}
//               totalCount={(data && data?.notifications?.totalCount) || 0}
//               totalPages={(data && data?.notifications?.totalPages) || 0}
//               pageSize={filters.pageSize}
//               currentPageNo={filters.pageNo}
//             />
//           )}
//         </TabPane>
//       </TabContent>

//       {/* Custom Notification Modal */}
//       <FSBModal
//         title="Send Custom Notification"
//         closeButtonLabel=""
//         confirmButtonLabel=""
//         message=""
//         open={showCustomNotification}
//         toggleAlert={toggleCustomNotification}
//         onClose={toggleCustomNotification}
//         modalClass="right-drawer notification-drawer"
//       >
//         <CustomNotification toggleCustomNotification={toggleCustomNotification} />
//       </FSBModal>

//       {/* What&apos;s New Modal */}
//       <FSBModal
//         title="What's New"
//         closeButtonLabel=""
//         confirmButtonLabel=""
//         message=""
//         open={showWhatsNew}
//         toggleAlert={toggleWhatsNew}
//         onClose={toggleWhatsNew}
//         modalClass="right-drawer notification-drawer"
//       >
//         <WhatsNew toggleWhatsNew={toggleWhatsNew} />
//       </FSBModal>

//       {/* What&apos;s New Static Sidebar */}
//       {showWhatsNewStatic && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 0,
//             right: 0,
//             width: '400px',
//             height: '100vh',
//             background: '#fff',
//             boxShadow: '-2px 0 10px rgba(0,0,0,0.2)',
//             zIndex: 9999,
//             overflowY: 'auto',
//           }}
//         >
//           <WhatsNewStatic onClose={toggleWhatsNewStatic} />
//         </div>
//       )}

//       {/* Custom Notification Static Sidebar */}
//       {showCustomNotificationStatic && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 0,
//             right: 0,
//             width: '400px',
//             height: '100vh',
//             background: '#fff',
//             boxShadow: '-2px 0 10px rgba(0,0,0,0.2)',
//             zIndex: 9999,
//             overflowY: 'auto',
//           }}
//         >
//           <CustomNotificationStatic onClose={toggleCustomNotificationStatic} />
//         </div>
//       )}

//       {/* Backdrop for sidebars */}
//       {(showWhatsNewStatic || showCustomNotificationStatic) && (
//         <div
//           onClick={handleBackdropClick}
//           onKeyDown={handleBackdropKeyDown}
//           role="button"
//           tabIndex={0}
//           aria-label="Close sidebar"
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             width: '100%',
//             height: '100%',
//             background: 'rgba(0,0,0,0.5)',
//             zIndex: 9998,
//           }}
//         />
//       )}
//     </>
//   );
// };

// export default AllNotification;

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, TabContent, TabPane } from 'reactstrap';
import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';
import { useQuery, useLazyQuery } from '@apollo/client';
import { ExternalLink } from 'lucide-react';
import { toast } from 'react-toastify';
import {
  NOTIFICATION_QUERY,
  NOTIFICATION_SUBSCRIPTION_QUERY,
} from 'pages/Notifications/NotificationGraphQL';
import { setVendorDetails } from 'actions/vendorDetailsAction';
import Loader from 'components/common/Loader';
import moment from 'moment';
import FSBModal from 'components/common/FSBModal';
import NoDataFound from 'components/NoDataFound';
import { NOTIFICATION_TABS_HEADING } from 'pages/Products/constant';
import CustomTabs from 'components/CustomTabs';
import { ORDER_LIST } from 'utils/CommonGraphQL';
import EditOrderWrapper from 'pages/Orders/components/EditOrderWrapper';
import Notifications from '../Notifications';
import CustomNotification from '../CustomNotification';
import WhatsNew from './Whatsnew/index';
import WhatsNewStatic from './WhatsNewStatic';
import CustomNotificationStatic from './CustomNotificationStatic';
import 'react-datepicker/dist/react-datepicker.css';
import './AllNotification.css';
import DateRangeFilter from './DateRangePicker';

const AllNotification = () => {
  // Keeps the list current even when the GraphQL subscription connection is unavailable.
  const NOTIFICATION_REFRESH_INTERVAL = 10000;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showCustomNotification, setShowCustomNotification] = useState(false);
  const [showWhatsNew, setShowWhatsNew] = useState(false);

  // States for Edit Order drawer
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showEditOrderModal, setShowEditOrderModal] = useState(false);
  const [fetchOrder] = useLazyQuery(ORDER_LIST, {
    fetchPolicy: 'network-only',
  });

  // New states for static sidebars
  const [showWhatsNewStatic, setShowWhatsNewStatic] = useState(false);
  const [showCustomNotificationStatic, setShowCustomNotificationStatic] =
    useState(false);

  const toggleCustomNotification = () => {
    setShowCustomNotification(!showCustomNotification);
  };

  const toggleWhatsNew = () => {
    setShowWhatsNew(!showWhatsNew);
  };

  // New toggle functions for static sidebars
  const toggleWhatsNewStatic = () => {
    setShowWhatsNewStatic(!showWhatsNewStatic);
  };

  const toggleCustomNotificationStatic = () => {
    setShowCustomNotificationStatic(!showCustomNotificationStatic);
  };

  const todayDate = new Date();
  const date = moment(todayDate);
  const yesterdayDate = date.subtract(1, 'days').toDate();
  const yesterDateAndTimeMilliseconds = yesterdayDate.valueOf();

  const [activeTab, setActiveTab] = useState(NOTIFICATION_TABS_HEADING.ALL);

  const defaultFilter = {
    filter: [
      {
        key: 'forAdminOnly',
        value: true,
        type: 'BOOLEAN',
        op: 'EQ',
      },
    ],
    pageNo: 1,
    pageSize: 10,
    sortCol: null,
    sortDirection: null,
  };

  const [filters, setFilters] = useState(
    JSON.parse(JSON.stringify(defaultFilter)),
  );
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });

  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo,
      pageSize,
    });
  };

  const getValue = (tab) => {
    if (NOTIFICATION_TABS_HEADING.BIDS === tab) {
      return 'bid';
    }
    if (NOTIFICATION_TABS_HEADING.ORDERS === tab) {
      return 'order';
    }
    if (NOTIFICATION_TABS_HEADING.USERS === tab) {
      return ['trader'];
    }
    if (NOTIFICATION_TABS_HEADING.OFFER === tab) {
      return 'offer';
    }
    if (NOTIFICATION_TABS_HEADING.DEMAND === tab) {
      return ['demand', 'NEW_DEMAND'];
    }
    if (NOTIFICATION_TABS_HEADING.OTHERS === tab) {
      return ['bid', 'order', 'KYC', 'offer', 'demand', 'NEW_DEMAND', 'trader'];
    }
  };

  const toggle = (tab) => {
    setDateRange({ startDate: null, endDate: null });
    if (activeTab !== tab) {
      if (NOTIFICATION_TABS_HEADING.ALL === tab) {
        setFilters(JSON.parse(JSON.stringify(defaultFilter)));
      } else {
        const value = getValue(tab);
        const isArray = Array.isArray(value);

        let filterConfig;

        if (
          tab === NOTIFICATION_TABS_HEADING.DEMAND ||
          tab === NOTIFICATION_TABS_HEADING.USERS
        ) {
          filterConfig = {
            key: 'typeName',
            value: value.join(','),
            type: 'STRING',
            op: 'IN',
          };
        } else if (tab === NOTIFICATION_TABS_HEADING.OTHERS) {
          filterConfig = {
            key: 'typeName',
            value: value.join(','),
            type: 'STRING',
            op: 'NOT_IN',
          };
        } else {
          filterConfig = {
            key: 'typeName',
            value,
            type: 'STRING',
            op: 'EQ',
          };
        }

        setFilters({
          ...JSON.parse(JSON.stringify(defaultFilter)),
          filter: [...defaultFilter.filter, filterConfig],
        });
      }
      setActiveTab(tab);
    }
  };

  const { data, loading, error, subscribeToMore } = useQuery(
    NOTIFICATION_QUERY,
    {
      variables: filters,
      fetchPolicy: 'network-only',
      pollInterval: NOTIFICATION_REFRESH_INTERVAL,
      notifyOnNetworkStatusChange: false,
    },
  );

  useEffect(() => {
    const unsubscribe = subscribeToMore({
      document: NOTIFICATION_SUBSCRIPTION_QUERY,
      variables: filters,
      updateQuery: (prev, { subscriptionData }) => {
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;
        return subscriptionData.data;
      },
    });
    return () => unsubscribe();
  }, [filters, subscribeToMore]);

  const isFreightNotification = (notification) => {
    if (!notification) return false;
    const message = (notification.message || '').toLowerCase();
    const typeName = (notification.typeName || '').toLowerCase();
    return (
      message.includes('freight') ||
      typeName.includes('freight') ||
      typeName === 'freight'
    );
  };

  const extractOrderId = (notification) => {
    if (!notification) return null;
    const message = notification.message || '';

    // 1. Check direct object properties if present
    if (notification.orderId && !Number.isNaN(Number(notification.orderId))) {
      return Number(notification.orderId);
    }
    if (notification.order?.id && !Number.isNaN(Number(notification.order.id))) {
      return Number(notification.order.id);
    }
    if (notification.entityId && !Number.isNaN(Number(notification.entityId))) {
      return Number(notification.entityId);
    }
    if (notification.referenceId && !Number.isNaN(Number(notification.referenceId))) {
      return Number(notification.referenceId);
    }

    // 2. Match #ODR_<date>_<orderId>
    const odrDateMatch = message.match(/#ODR_[A-Za-z0-9]+_([0-9,]+)/i);
    if (odrDateMatch && odrDateMatch[1]) {
      const cleanedId = odrDateMatch[1].replace(/,/g, '');
      if (!Number.isNaN(Number(cleanedId)) && Number(cleanedId) > 0) return Number(cleanedId);
    }

    // 3. Match #ODR_<orderId>
    const odrMatch = message.match(/#ODR_([0-9,]+)/i);
    if (odrMatch && odrMatch[1]) {
      const cleanedId = odrMatch[1].replace(/,/g, '');
      if (!Number.isNaN(Number(cleanedId)) && Number(cleanedId) > 0) return Number(cleanedId);
    }

    // 4. Match order (id/no/#/:/-) 1234 or order(1234) or order: 1234 or order # 1234
    const orderMatch = message.match(/\border\b[^\d]*?([0-9,]+)/i);
    if (orderMatch && orderMatch[1]) {
      const cleanedId = orderMatch[1].replace(/,/g, '');
      if (!Number.isNaN(Number(cleanedId)) && Number(cleanedId) > 0) return Number(cleanedId);
    }

    // 5. Match #1234
    const hashMatch = message.match(/#([0-9,]+)/);
    if (hashMatch && hashMatch[1]) {
      const cleanedId = hashMatch[1].replace(/,/g, '');
      if (!Number.isNaN(Number(cleanedId)) && Number(cleanedId) > 0) return Number(cleanedId);
    }

    // 6. Match for 1234 or for #1234
    const forMatch = message.match(/\bfor\b[^\d]*?([0-9,]+)/i);
    if (forMatch && forMatch[1]) {
      const cleanedId = forMatch[1].replace(/,/g, '');
      if (!Number.isNaN(Number(cleanedId)) && Number(cleanedId) > 0) return Number(cleanedId);
    }

    // 7. Any 3 to 7 digit number (excluding 10+ digit phone numbers)
    const allNumbers = message.match(/\b\d{3,7}\b/g);
    if (allNumbers && allNumbers.length) {
      const lastNum = Number(allNumbers[allNumbers.length - 1]);
      if (!Number.isNaN(lastNum) && lastNum > 0) return lastNum;
    }

    return null;
  };

  const handleClick = async (val) => {
    const notification = val?.message ? val : null;
    const traderData = val?.trader || (val?.message ? null : val);

    const message = (notification?.message || '').toLowerCase();

    // FOR request notifications should open the customer request list directly.
    if (/^new\s+for\s+request\s+received\b/i.test(notification?.message?.trim() || '')) {
      navigate('/delivered-rate?tab=request-rate&requestTab=customer-request');
      return;
    }

    const orderId = extractOrderId(notification);

    // "submitted a purchase request" -> go to Approval tab
    if (message.includes('submitted a purchase request')) {
      if (orderId) {
        navigate(`/orders/${orderId}?tab=Approval`, {
          state: { tab: 'Approval' },
        });
        return;
      }
      navigate('/orders');
      return;
    }

    // "freight charge accepted" with "accept or reject" -> go to Approval tab
    if (message.includes('freight charge accepted') && message.includes('accept or reject')) {
      if (orderId) {
        navigate(`/orders/${orderId}?tab=Approval`, {
          state: { tab: 'Approval' },
        });
        return;
      }
      navigate('/orders');
      return;
    }

    // Freight notifications (like "initiate freight arrangement") -> open Edit Order modal
    const isFreight = isFreightNotification(notification);
    if (isFreight) {
      if (orderId) {
        try {
          const res = await fetchOrder({
            variables: {
              filter: [{ key: 'id', value: orderId, type: 'INT', op: 'EQ' }],
            },
          });
          const orderData = res?.data?.orders?.orders?.[0];
          if (orderData) {
            setSelectedOrder(orderData);
            setShowEditOrderModal(true);
            return;
          }
          // Order not found, open vendor drawer instead
          if (traderData?.id) {
            dispatch(
              setVendorDetails({
                status: true,
                selectedVendor: traderData,
              }),
            );
          }
        } catch (err) {
          console.error('Error fetching order:', err);
          // On error, open vendor drawer instead
          if (traderData?.id) {
            dispatch(
              setVendorDetails({
                status: true,
                selectedVendor: traderData,
              }),
            );
          }
        }
        return;
      }
    }

    // For non-freight notifications with orderId, open Edit Order modal
    if (orderId) {
      try {
        const res = await fetchOrder({
          variables: {
            filter: [{ key: 'id', value: orderId, type: 'INT', op: 'EQ' }],
          },
        });
        const orderData = res?.data?.orders?.orders?.[0];
        if (orderData) {
          setSelectedOrder(orderData);
          setShowEditOrderModal(true);
          return;
        }
        // Order not found, open vendor drawer instead
        if (traderData?.id) {
          dispatch(
            setVendorDetails({
              status: true,
              selectedVendor: traderData,
            }),
          );
        }
      } catch (err) {
        console.error('Error fetching order:', err);
        // On error, open vendor drawer instead
        if (traderData?.id) {
          dispatch(
            setVendorDetails({
              status: true,
              selectedVendor: traderData,
            }),
          );
        }
      }
      return;
    }

    // Fallback to vendor drawer for other notifications
    if (traderData?.id) {
      dispatch(
        setVendorDetails({
          status: true,
          selectedVendor: traderData,
        }),
      );
    }
  };

  const handleWhatsNewStaticClick = () => {
    toggleWhatsNewStatic();
  };

  const handleWhatsNewStaticKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleWhatsNewStatic();
    }
  };

  const handleBackdropClick = () => {
    setShowWhatsNewStatic(false);
    setShowCustomNotificationStatic(false);
  };

  const handleBackdropKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setShowWhatsNewStatic(false);
      setShowCustomNotificationStatic(false);
    }
  };

  if (loading)
    return (
      <div className="pb-5">
        <Loader />
      </div>
    );
  if (error) return `There is an error on this page : ${error.message} `;
  if (!data?.notifications?.notifications)
    return (
      <div className="pb-5">
        <NoDataFound message="Notifications not available" />
      </div>
    );

  return (
    <>
      <div className="text-end d-flex justify-content-end gap-3 notification-toolbar">
        {/* What&apos;s New Section */}
        <div className="d-flex align-items-center gap-2">
          <Button
            color="warning"
            className="text-nowrap mb-3 mt-sm-0 d-flex align-items-center gap-2"
            size="sm"
            onClick={toggleWhatsNew}
            style={{ border: 'none', background: '#2378C9', color: 'white' }}
          >
            What&apos;s New
          </Button>

          <div
            onClick={handleWhatsNewStaticClick}
            onKeyDown={handleWhatsNewStaticKeyDown}
            role="button"
            tabIndex={0}
            aria-label="Open What's New in new sidebar"
            style={{
              cursor: 'pointer',
              background: '#2378C9',
              borderRadius: '50%',
              width: '32px',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '19px',
            }}
          >
            <ExternalLink size={18} color="white" />
          </div>
        </div>

        {/* Custom Notification Section */}
        <div className="d-flex align-items-center gap-2">
          <Button
            color="primary"
            className="text-nowrap mb-3 mt-sm-0 d-flex align-items-center gap-2"
            size="sm"
            onClick={toggleCustomNotification}
          >
            Custom Notification
          </Button>
        </div>
      </div>

      <div className="notification-tab-row" style={{ position: 'relative' }}>
        <CustomTabs
          tabs={[
            NOTIFICATION_TABS_HEADING.ALL,
            NOTIFICATION_TABS_HEADING.ORDERS,
            NOTIFICATION_TABS_HEADING.BIDS,
            NOTIFICATION_TABS_HEADING.USERS,
            NOTIFICATION_TABS_HEADING.OFFER,
            NOTIFICATION_TABS_HEADING.DEMAND,
            NOTIFICATION_TABS_HEADING.OTHERS,
          ]}
          selectedTab={activeTab}
          onTabChange={toggle}
          className="mb-2"
        />
        <div
          className="notification-date-wrapper"
          style={{ position: 'absolute', right: 0, top: 0 }}
        >
          <DateRangeFilter
            dateRange={dateRange}
            onFilter={({ startDate, endDate }) => {
              if (!startDate && !endDate) {
                setDateRange({ startDate: null, endDate: null });
                setFilters((prev) => ({
                  ...prev,
                  filter: [
                    ...prev.filter.filter(
                      (filter) => filter?.key !== 'createdAt',
                    ),
                  ],
                }));
                return;
              }
              setDateRange({ startDate, endDate });
              setFilters((prev) => ({
                ...prev,
                filter: [
                  ...prev.filter.filter(
                    (filter) => filter?.key !== 'createdAt',
                  ),
                  {
                    key: 'createdAt',
                    value: startDate.valueOf(),
                    type: 'DATE',
                    op: 'GTE',
                  },
                  {
                    key: 'createdAt',
                    value: endDate.valueOf(),
                    type: 'DATE',
                    op: 'LTE',
                  },
                ],
              }));
            }}
          />
        </div>
      </div>

      <TabContent activeTab={activeTab}>
        <TabPane tabId={NOTIFICATION_TABS_HEADING.ALL}>
          {activeTab === NOTIFICATION_TABS_HEADING.ALL && (
            <Notifications
              handlePageChange={handlePageChange}
              data={data}
              handleClick={handleClick}
              totalCount={(data && data?.notifications?.totalCount) || 0}
              totalPages={(data && data?.notifications?.totalPages) || 0}
              pageSize={filters.pageSize}
              currentPageNo={filters.pageNo}
            />
          )}
        </TabPane>
        <TabPane tabId={NOTIFICATION_TABS_HEADING.BIDS}>
          {activeTab === NOTIFICATION_TABS_HEADING.BIDS && (
            <Notifications
              handlePageChange={handlePageChange}
              data={data}
              handleClick={handleClick}
              totalCount={(data && data?.notifications?.totalCount) || 0}
              totalPages={(data && data?.notifications?.totalPages) || 0}
              pageSize={filters.pageSize}
              currentPageNo={filters.pageNo}
            />
          )}
        </TabPane>
        <TabPane tabId={NOTIFICATION_TABS_HEADING.ORDERS}>
          {activeTab === NOTIFICATION_TABS_HEADING.ORDERS && (
            <Notifications
              handlePageChange={handlePageChange}
              data={data}
              handleClick={handleClick}
              totalCount={(data && data?.notifications?.totalCount) || 0}
              totalPages={(data && data?.notifications?.totalPages) || 0}
              pageSize={filters.pageSize}
              currentPageNo={filters.pageNo}
            />
          )}
        </TabPane>
        <TabPane tabId={NOTIFICATION_TABS_HEADING.USERS}>
          {activeTab === NOTIFICATION_TABS_HEADING.USERS && (
            <Notifications
              handlePageChange={handlePageChange}
              data={data}
              handleClick={handleClick}
              totalCount={(data && data?.notifications?.totalCount) || 0}
              totalPages={(data && data?.notifications?.totalPages) || 0}
              pageSize={filters.pageSize}
              currentPageNo={filters.pageNo}
            />
          )}
        </TabPane>
        <TabPane tabId={NOTIFICATION_TABS_HEADING.OFFER}>
          {activeTab === NOTIFICATION_TABS_HEADING.OFFER && (
            <Notifications
              handlePageChange={handlePageChange}
              data={data}
              handleClick={handleClick}
              totalCount={(data && data?.notifications?.totalCount) || 0}
              totalPages={(data && data?.notifications?.totalPages) || 0}
              pageSize={filters.pageSize}
              currentPageNo={filters.pageNo}
            />
          )}
        </TabPane>
        <TabPane tabId={NOTIFICATION_TABS_HEADING.DEMAND}>
          {activeTab === NOTIFICATION_TABS_HEADING.DEMAND && (
            <Notifications
              handlePageChange={handlePageChange}
              data={data}
              handleClick={handleClick}
              totalCount={(data && data?.notifications?.totalCount) || 0}
              totalPages={(data && data?.notifications?.totalPages) || 0}
              pageSize={filters.pageSize}
              currentPageNo={filters.pageNo}
            />
          )}
        </TabPane>
        <TabPane tabId={NOTIFICATION_TABS_HEADING.OTHERS}>
          {activeTab === NOTIFICATION_TABS_HEADING.OTHERS && (
            <Notifications
              handlePageChange={handlePageChange}
              data={data}
              handleClick={handleClick}
              totalCount={(data && data?.notifications?.totalCount) || 0}
              totalPages={(data && data?.notifications?.totalPages) || 0}
              pageSize={filters.pageSize}
              currentPageNo={filters.pageNo}
            />
          )}
        </TabPane>
      </TabContent>

      {/* Custom Notification Modal */}
      <FSBModal
        title="Send Custom Notification"
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        open={showCustomNotification}
        toggleAlert={toggleCustomNotification}
        onClose={toggleCustomNotification}
        modalClass="right-drawer notification-drawer"
      >
        <CustomNotification
          toggleCustomNotification={toggleCustomNotification}
        />
      </FSBModal>

      {/* What&apos;s New Modal */}
      <FSBModal
        title="What's New"
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        open={showWhatsNew}
        toggleAlert={toggleWhatsNew}
        onClose={toggleWhatsNew}
        modalClass="right-drawer notification-drawer"
      >
        <WhatsNew toggleWhatsNew={toggleWhatsNew} />
      </FSBModal>

      {/* What&apos;s New Static Sidebar */}
      {showWhatsNewStatic && (
        <div className="notification-static-drawer">
          <WhatsNewStatic onClose={toggleWhatsNewStatic} />
        </div>
      )}

      {/* Custom Notification Static Sidebar */}
      {showCustomNotificationStatic && (
        <div className="notification-static-drawer">
          <CustomNotificationStatic onClose={toggleCustomNotificationStatic} />
        </div>
      )}

      {/* Edit Order Modal */}
      {showEditOrderModal && selectedOrder && (
        <FSBModal
          title="Edit Order"
          closeButtonLabel=""
          confirmButtonLabel=""
          message=""
          open={showEditOrderModal}
          onClose={() => {
            setShowEditOrderModal(false);
            setSelectedOrder(null);
          }}
          toggleAlert={() => {
            setShowEditOrderModal(false);
            setSelectedOrder(null);
          }}
          modalClass="right-drawer-v2"
        >
          <EditOrderWrapper
            currentRow={selectedOrder}
            onCloseOrderPopup={() => {
              setShowEditOrderModal(false);
              setSelectedOrder(null);
            }}
            onOrderUpdated={async () => {
              if (selectedOrder?.id) {
                const res = await fetchOrder({
                  variables: {
                    filter: [
                      {
                        key: 'id',
                        value: selectedOrder.id,
                        type: 'INT',
                        op: 'EQ',
                      },
                    ],
                  },
                });
                if (res?.data?.orders?.orders?.[0]) {
                  setSelectedOrder(res.data.orders.orders[0]);
                }
              }
            }}
          />
        </FSBModal>
      )}

      {/* Backdrop for sidebars */}
      {(showWhatsNewStatic || showCustomNotificationStatic) && (
        <div
          onClick={handleBackdropClick}
          onKeyDown={handleBackdropKeyDown}
          role="button"
          tabIndex={0}
          aria-label="Close sidebar"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0,0,0,0.5)',
            zIndex: 9998,
          }}
        />
      )}
    </>
  );
};

export default AllNotification;
